import { LOCATION_SEARCH_TYPE } from '../types'

export function containsAllAirport(
  item: LOCATION_SEARCH_TYPE | Record<string, never> | null
) {
  return item?.itemName?.includes('- All Airports')
}

export function formatAllAirport(
  item: LOCATION_SEARCH_TYPE | Record<string, never> | null
) {
  return `${item?.itemName?.split('- All Airports')[0]}(All Airports)`
}
